module.exports = __webpack_public_path__ + "img/pherrol7.41c9de82.jpg";